<template>
	<c-dialog ref="dialog" width="750" height="500" button-name="确认并提交" @resolve="submitHandle">
		<c-form ref="form" unit-width="400">
			<c-form-item type="hidden" name="tz_id"></c-form-item>
			<c-form-item v-model="currentProjectId" type="select" label="所属项目" name="project_id" :options="projectList" required :disabled="editState"></c-form-item>
			<c-form-item type="input" label="企业单位" name="zbqy_name" required disabled></c-form-item>
			<c-form-item type="input" label="监理单位" name="jldw_name" required disabled></c-form-item>
			<c-form-item type="input" label="业主单位" name="yzdw_name" required disabled></c-form-item>
			<c-form-item type="file" label="审批材料" name="file_path" required file-type="pdf" file-size="3072"></c-form-item>
			<c-form-item type="textarea" label="备注说明" name="remark"></c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				editState: false,
				projectList: [],
				currentProjectId: ''
			}
		},
		
		watch: {
			currentProjectId(val) {
				if (val) {
					this.request({
						url: '/project/detail',
						data: {
							project_id: val
						},
						success: data => {
							this.$refs.form.set({
								yzdw_name: data.project_info.yzdw_name,
								jldw_name: data.project_info.jldw_name,
								zbqy_name: data.project_info.zbqy_name
							});
						}
					});
				}
			}
		},
		
		mounted() {
			this.request({
				url: '/project/select_list',
				data: {
					type: 5
				},
				success: data => {
					this.projectList = Array.from(data, item => {
						return {
							name: item.name,
							value: item.id
						}
					});
				}
			});
		},
		
		methods: {
			open(id) {
				this.editState = !!id;
				this.$refs.form.clear();
				if (id) {
					this.request({
						url: '/project/aqtz/detail',
						data: {
							tz_id: id
						},
						loading: true,
						success: data => {
							this.$refs.form.set({
								tz_id: data.tzInfo.id
							});
							this.$refs.form.set(data.tzInfo);
							this.$refs.dialog.open({
								title: '编辑安全台账任务'
							});
						}
					});
				} else {
					this.$refs.dialog.open({
						title: '新建安全台账任务'
					});
				}
			},
			
			submitHandle(stop, next) {
				stop();
				
				this.$refs.form.submit({
					url: this.editState ? '/project/aqtz/updateBase' : '/project/aqtz/add',
					rule: {
						project_id: '请选择所属项目',
						file_path: '请上传审批材料'
					},
					success: () => {
						next();
						this.$message({
							text: '提交成功'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>